import { init } from "@sentry/react";

init({
  dsn: "https://d3e9f4103e6b214c5cf80a8dab625e43@o4508976415309824.ingest.de.sentry.io/4509280873939024",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: process.env.NODE_ENV ?? "development",
});
